import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=96de4a8e&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=96de4a8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96de4a8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96de4a8e')) {
      api.createRecord('96de4a8e', component.options)
    } else {
      api.reload('96de4a8e', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=96de4a8e&scoped=true&", function () {
      api.rerender('96de4a8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2a7wQ6dhbMo6h/JS/comp/DateRangeExt.vue"
export default component.exports